import ValidatorInterface from './validatorInterface';

/**
 * @class ValidationWatcher
 * @extends EventEmitter
 */
export default class ChainValidator {
    validators = [];

    constructor(validators) {
        this.validators = validators;
        this.validators.forEach(validator => ValidatorInterface.assert(validator));
    }

    /**
     * @param {AbstractItem} item
     * @return {ValidationResult[]}
     */
    validateItem(item) {
        return this.validators
            .map(validator => validator.validateItem(item))
            .reduce((flattened, results) => flattened.concat(results), []);
    }
}
